import React, { useState, useEffect } from 'react';
import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { PageTitle, Loading } from '@cordata/buffet';

import Identity from '~/assets/identity.svg';

import Welcome from '~/components/B2W/Welcome/Form';
import ConfirmRegistration from '~/components/B2W/ConfirmRegistration/Form';
import Assessment from '~/components/B2W/Assessment/Form';

const B2W = () => {
  const [registered, setRegistered] = useState();
  const [registrationInfo, setRegistrationInfo] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    setRegistrationInfo(localStorage.getItem('registration-info'));
    setRegistered(localStorage.getItem('registration-code') && localStorage.getItem('registration-info'));

    setLoading(false);
  }, []);

  return (
    <>
      <Navbar color="primary" dark expand="md" className="mb-3 sticky-top" style={{ height: '56px' }}>
        <NavbarBrand>
          <img src={Identity} width={130} alt="Navigator - Cordata" className="mr-2" />
        </NavbarBrand>
      </Navbar>

      <Container>
        <PageTitle>Back to Work</PageTitle>

        {/* eslint-disable no-nested-ternary */}
        {loading
          ? <Loading />
          : registered
            ? <Assessment />
            : registrationInfo
              ? <ConfirmRegistration />
              : <Welcome />
        }
      </Container>
    </>
  );
};

export default B2W;
